import { render, staticRenderFns } from "./editDomain.vue?vue&type=template&id=92e2dedc&scoped=true&"
import script from "./editDomain.vue?vue&type=script&lang=js&"
export * from "./editDomain.vue?vue&type=script&lang=js&"
import style0 from "./editDomain.vue?vue&type=style&index=0&id=92e2dedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e2dedc",
  null
  
)

export default component.exports